import { render, staticRenderFns } from "./BucketBoardViewTab.vue?vue&type=template&id=13bae492"
import script from "./BucketBoardViewTab.vue?vue&type=script&lang=js"
export * from "./BucketBoardViewTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports